import request from "@/utils/request.js"

//询价
const inquiry = {
    import: params => request.post("/api/Project/Inquiry/Import", params),//导入
    submit: params => request.post("/api/Project/Inquiry/Submit", params),//保存
    list: params => request.post("/api/Project/Inquiry/GetList", params),//分页列表
    plains: params => request.post("/api/Project/Inquiry/GetPlainList", params),//简单列表
    pendings: params => request.post("/api/Project/Inquiry/GetPendings", params),//最新任务
    logs: params => request.get("/api/Project/Inquiry/GetLogs", { params }),//操作记录
    detail: params => request.get("/api/Project/Inquiry/GetInfo", { params }),//详情
    grabbing: params => request.get("/api/Project/Inquiry/SetGrabbing", { params }),//截单
    dispatch: params => request.get("/api/Project/Inquiry/SetDispatch", { params }),//派单
    quote: params => request.post("/api/Project/Inquiry/SetQuote", params),//报价
    complete: params => request.post("/api/Project/Inquiry/SetComplete", params),//投标
    outbounds: params => request.get("/api/Project/Inquiry/SetOutbounds", { params }),//关联出库单
    feedback: params => request.get("/api/Project/Inquiry/SetFeedback", { params }),//反馈记录
    reset: params => request.get("/api/Project/Inquiry/SetReset", { params }),//放弃、重置
    delete: params => request.get("/api/Project/Inquiry/Delete", { params }),//删除
    group_date: params => request.get('/api/Project/Inquiry/GroupByDate', { params }),//日期分组
}

//报备
const enroll = {
    list: params => request.post("/api/Project/Enroll/GetList", params),
    detail: params => request.get("/api/Project/Enroll/GetInfo", { params }),
    submit: params => request.post("/api/Project/Enroll/Submit", params),
    audit: params => request.post("/api/Project/Enroll/Audit", params),
    nullify: params => request.get("/api/Project/Enroll/Nullify", { params }),
    delete: params => request.get("/api/Project/Enroll/Delete", { params })
}


export default {
    inquiry,
    enroll,
}